/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { UcSession } from '../ai-query-oidc/types';
import { SESSION_USERKEY } from '../ai-query-oidc/constants';
import {
  readAuthorizationFromCookie,
  readTenantIdFromCookie,
} from './read-authorization-cookie';

function readTenantIdFromSession(): string | undefined {
  try {
    const raw = sessionStorage.getItem('userInfo');
    if (!raw) {
      return undefined;
    }
    const info = JSON.parse(raw) as Record<string, unknown>;
    const tenantId = info.tenantId ?? info.tenant_id;
    return typeof tenantId === 'string' && tenantId.trim()
      ? tenantId.trim()
      : undefined;
  } catch (error) {
    void error;
    return undefined;
  }
}

/**
 * 读取 UC userkey：优先 Authorization Cookie（UC 登录写入），兼容 sessionStorage。
 */
export function ensureCozeUcSession(): UcSession | null {
  const userkey =
    readAuthorizationFromCookie() ||
    sessionStorage.getItem(SESSION_USERKEY)?.trim() ||
    '';
  if (!userkey) {
    return null;
  }

  return {
    userkey,
    tenant_id: readTenantIdFromCookie() || readTenantIdFromSession(),
  };
}
